import include from '@/views/boards/single-page/include.js'

const titleColumnNames = {
  813: '소분류',
  814: '소분류',
  845: '공사/작업명',
  899: '활동명',
}

export default function getPostTitle(data) {
  const boardId = data.board_id || (data.post && data.post.board_id)
  if (!boardId) return ''

  const columnName = titleColumnNames[boardId]
  if (!columnName) return ''

  const listConfig = include.list[`${boardId  }_list`]
  if (!listConfig) return ''

  const heads = listConfig.getHead()
  const titleHead = heads.find(h => h.name === columnName)
  if (!titleHead || !titleHead.key) return ''

  try {
    let content = JSON.parse(data.post_content)
    const keys = titleHead.key.split('.')
    for (const key of keys) {
      content = content[key]
      if (content === undefined || content === null) return ''
    }
    return typeof content === 'string' ? content : ''
  } catch (e) {
    return ''
  }
}
